export class TranslateQuestionModel {

  public questionText = '';

  public rightAnswer = {
    answerText: ''
  };

  public answers = [
    {
      answerText: ''
    },
    {
      answerText: ''
    },
    {
      answerText: ''
    }
  ];

  constructor() {

  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/models/translate-question.model.ts